import React from 'react';
import { DayPicker } from 'react-day-picker';
import "react-day-picker/style.css";
import { clsx } from 'clsx';

const DatePicker = ({selected, onSelect, isInvalid, errorMessage }: {selected: string, onSelect: any, isInvalid: boolean; errorMessage?: string }) => {

  const selectedDate = new Date(selected);

  return (
    <div className={
      clsx(
        'flex flex-col border rounded-2xl p-4',
        isInvalid ? 'border-red-500': 'border-transparent',
      )}>
      <DayPicker
        animate
        mode="single"
        selected={selectedDate}
        onSelect={onSelect}
      />

      {isInvalid && errorMessage ? (
        <p className="mt-1 ml-3 text-xs text-red-500 flex-wrap">{errorMessage}</p>
      ) : null}
    </div>
  );
};

export default DatePicker;